<script setup lang="ts">
/**
 * Entry page for the flow
 * --------------------------------------------------------------------------------------------------
 * This page is SERVER-SIDE-RENDERED and serves as a fast-loaded entry point
 * to the product flow. it resets all stores.
 */
definePageMeta({
    layout: 'empty',
    path: '/booking/harder-kulm/start',
    title: 'offerFlow.splashMessage.harder-kulm',
});

onMounted(() => {
    useResetStores().resetOfferFlow();
    useStartFreshFlow().startFreshFlow(productConfigHarderKulm);
});
</script>

<template>
    <IntroLoader />
</template>
